export default __webpack_public_path__ + "static/media/ParentsPLUSbg-fixed.174ad8e1.mp4";